import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { RwgTokenConversionRequest } = protos;

export function rwgTokenConversion(token: string, merchantChange: number): ApiAction {
  return {
    TockApi: {
      postProto: '/google/rwg-paid-conversion',
      type: AppConstants.RWG_TOKEN_CONVERSION,
      request: RwgTokenConversionRequest.fromObject({ token, merchantChange }),
    },
  };
}
